import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

const PrivacyPolicyModal = ({ open, onClose, onAgree }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>プライバシーポリシー</DialogTitle>
      <DialogContent dividers>
        <Typography paragraph>
          1. 個人情報の収集について
        </Typography>
        <Typography paragraph>
          ClachSyncは、以下の個人情報を収集する場合があります：
          • メールアドレス
          • アカウント情報
          • その他サービス利用に必要な情報
        </Typography>
        <Typography paragraph>
          2. 個人情報の利用目的
        </Typography>
        <Typography paragraph>
          収集した個人情報は、以下の目的で利用されます：
          • サービスの提供・運営
          • ユーザーサポート
          • サービスの改善・新機能の開発
          • 重要なお知らせの送信
        </Typography>
        <Typography paragraph>
          3. 個人情報の管理
        </Typography>
        <Typography paragraph>
          ClachSyncは、収集した個人情報の管理について、適切な安全対策を講じます。
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          キャンセル
        </Button>
        <Button onClick={onAgree} variant="contained" color="primary">
          同意して登録
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyPolicyModal;
